import { QueryHookOptions, useQuery } from '@apollo/client';
import { AccessLevel } from 'redux/authentication/enums';

import { USER_BY_ROLE_QUERY_FOR_CALENDAR_OF_TEACHER } from './queries';
import { User } from './types';

export const useUsersByRoleForCalendarOfTeacher = (role: AccessLevel, options?: QueryHookOptions) =>
  useQuery<{ users: User[] }>(USER_BY_ROLE_QUERY_FOR_CALENDAR_OF_TEACHER, { ...options, variables: { role } });
